import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { SnippetsPlugin } from '../snippetsPluginType';

import { getTemplateGalleryBlockMenuComponents } from './block-menu/getTemplateGalleryBlockMenuComponents';
import { getTemplateGalleryQuickInsertComponents } from './quick-insert/getTemplateGalleryQuickInsertComponents';

type Params = {
	api: Parameters<SnippetsPlugin>[0]['api'];
	openTemplateGallery?: () => void;
};

export const registerTemplateGalleryEntryPoints = ({ api, openTemplateGallery }: Params): void => {
	if (!openTemplateGallery) {
		return;
	}

	api?.blockMenu?.actions.registerBlockMenuComponents(
		getTemplateGalleryBlockMenuComponents(openTemplateGallery),
	);

	if (isExperimentEnabled('platform_editor_slash_command')) {
		api?.uiControlRegistry?.actions.register(
			getTemplateGalleryQuickInsertComponents({ api, onOpenTemplateGallery: openTemplateGallery }),
		);
	}
};
